document.addEventListener('DOMContentLoaded', function() {
    //console.log('DOM fully loaded and parsed');

    function applyScaleToMathJaxElements() {
        var elements = document.querySelectorAll('[id^="MathJax-Element-"]');
        elements.forEach(function(element) {
            if (element.id.endsWith('-Frame')) {
                //console.log('Applying scale to MathJax element:', element.id);
                element.style.fontSize = '100%';
            }
        });
    }

    function configureMathJax() {
        if (typeof MathJax !== 'undefined') {
            //console.log('Configuring MathJax');
            MathJax.Hub.Config({
                "HTML-CSS": {
                    scale: 100
                }
            });
            //console.log('Queueing MathJax Typeset');
            MathJax.Hub.Queue(["Typeset", MathJax.Hub], function() {
                //console.log('MathJax Typeset complete');
                applyScaleToMathJaxElements();
            });
        } else {
            console.error('MathJax is not available.');
        }
    }

    function handleVisibilityChange() {
        if (document.visibilityState === 'visible') {
            //console.log('Page became visible. Ensuring MathJax scale.');
            applyScaleToMathJaxElements();
        }
    }

    // Configure MathJax when the DOM is loaded
    //console.log('Initial MathJax configuration');
    configureMathJax();

    // Add listener for visibility change
    document.addEventListener('visibilitychange', function() {
        //console.log('Visibility change detected. State:', document.visibilityState);
        handleVisibilityChange();
    });

    // Add listener for pageshow event to ensure MathJax configures when the page is shown
    window.addEventListener('pageshow', function(event) {
        if (event.persisted) {
            //console.log('Page show event detected with persisted:', event.persisted);
            applyScaleToMathJaxElements();
        }
    });
});
